import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import femmeVelo from "../../assets/equipe.png";

const HeroNous = () => {
  const { t } = useTranslation("informations/HeroSection");

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 5, px: 2 }}>
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: "1200px",
          borderRadius: "20px",
          px: { xs: 3, md: 6 },
          pt: { xs: 4, md: 6 },
          pb: { xs: 4, md: 3 },
          backgroundColor: "#F8F8F8",
          position: "relative",
          fontFamily: "'Poppins', sans-serif",
          overflow: "hidden",
        }}
      >
        <Box sx={{ zIndex: 2 }}>
          {/* Titre */}
          <Typography
            gutterBottom
            sx={{
              color: "#000000",
              fontWeight: 900,
              fontSize: { xs: "2.2rem", md: "3.5rem" },
              lineHeight: 1.2,
              maxWidth: { xs: "100%", md: "65%" },
              mb: 2,
            }}
          >
            {t("title.part1")}{" "}
            <Box component="span" sx={{ color: "#449F2D" }}>
              {t("title.highlight")}
            </Box>{" "}
            {t("title.part2")}
          </Typography>

          {/* Paragraphe */}
          <Typography
            sx={{
              color: "#000000",
              fontWeight: 500,
              fontSize: "1.1rem",
              lineHeight: 1.6,
              mb: 4,
              maxWidth: { xs: "100%", md: "600px" },
            }}
          >
            {t("subtitle")}
          </Typography>
        </Box>

        {/* Image à droite */}
        <Box
          component="img"
          src={femmeVelo}
          alt={t("imageAlt")}
          sx={{
            position: "absolute",
            bottom: 0,
            right: -60,
            height: "320px",
            zIndex: 1,
            objectFit: "contain",
            pointerEvents: "none",
            display: { xs: "none", md: "block" },
          }}
        />
      </Paper>
    </Box>
  );
};

export default HeroNous;